import { DEFAULT_CATEGORY_ICON_SIZE, PARTNER_ASSET_PATH } from '~/constants';
import { MarketplacePartner } from '~/types/marketplace';

type CategoryIconProps = {
  partner?: MarketplacePartner;
  slug?: string | null;
  name: string;
  iconSize?: number;
};

export const CategoryIcon = ({
  partner,
  slug,
  name,
  iconSize = DEFAULT_CATEGORY_ICON_SIZE,
  ...props
}: CategoryIconProps) => {
  return (
    <img
      src={`${PARTNER_ASSET_PATH(partner)}/${slug}.svg`}
      alt={`${name} icon`}
      width={iconSize}
      height={iconSize}
      {...props}
    />
  );
};
